import { TdsIcon } from '@scania/tegel-react';
import { type ResponsiveTableColumn } from '@optimization/ssi-common';
import { type VehicleListColumnKey, type VehicleRowItem } from '..';
import StatusCell from './StatusCell';

export const warningColumn: ResponsiveTableColumn<VehicleRowItem, VehicleListColumnKey> = {
  columnTitle: <TdsIcon name="warning" size="20px" className="tds-text-warning" aria-hidden="true" />,
  ariaLabel: 'Warnings',
  columnKey: 'status',
  sortable: true,
  render: ({ vehicle }) => <StatusCell vehicleAlert={vehicle.vehicleAlert} />,
};
